"use strict";
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="307e0b9c-cb57-556f-a31f-6e9f64ff9174")}catch(e){}}();

Object.defineProperty(exports, "__esModule", { value: true });
exports.round = exports.formatCurrency = void 0;
const formatCurrency = (dollars) => {
    const numericValue = typeof dollars === "string"
        ? parseFloat(dollars.replace(/,/g, ""))
        : dollars;
    if (!Number.isFinite(numericValue))
        return "$0.00";
    const isNegative = numericValue < 0;
    const formattedAmount = `$${numericValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;
    return isNegative ? `-${formattedAmount}` : formattedAmount;
};
exports.formatCurrency = formatCurrency;
const round = (value) => {
    return Math.round(value * 100) / 100;
};
exports.round = round;
//# sourceMappingURL=numberFormatters.js.map
//# debugId=307e0b9c-cb57-556f-a31f-6e9f64ff9174
